import { render, staticRenderFns } from "./DeskActionButtons.vue?vue&type=template&id=67caa92d&scoped=true&"
import script from "./DeskActionButtons.vue?vue&type=script&lang=js&"
export * from "./DeskActionButtons.vue?vue&type=script&lang=js&"
import style0 from "./DeskActionButtons.vue?vue&type=style&index=0&id=67caa92d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67caa92d",
  null
  
)

export default component.exports